// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4bNdo","toggle":"styles_toggle__2Xwm8","preview":"styles_preview__IWE0c"};